<template>
    <v-app>
        <v-toolbar app>
            <v-toolbar-title class="headline text-uppercase">
                <span>FMM COMPOSITION</span> <span class="font-weight-light">Database</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>

            <v-toolbar-items>
                <v-btn flat :to="{name: 'samplesScreen'}">Samples</v-btn>
                <v-btn flat :to="{name: 'phasesScreen'}">Phases</v-btn>
                <v-btn flat :to="{name: 'searchScreen'}">Search</v-btn>
                <v-btn flat :to="{name: 'uploadScreen'}">Upload</v-btn>
            </v-toolbar-items>
        </v-toolbar>

        <v-content>
            <router-view></router-view>
        </v-content>
    </v-app>
</template>

<script>
  export default {
    name: 'App',
    components: {},
    data() {
      return {};
    },
  };
</script>
